<template>
<div>
    <v-container fluid grid-list-md px-0>
        <v-layout row wrap>
             <v-flex xs12>
                <v-snackbar
                    v-model="alert" 
                    color="green lighten-2" 
                    class="white--text" 
                    top outlined dense 
                    type="success" text>
                    {{ message }}
                    <v-btn color="white" flat text  @click="alert = false">  <v-icon color="maroon">mdi-close</v-icon></v-btn>
                </v-snackbar>
                 <v-snackbar
                    v-model="alert_error" 
                    color="red lighten-2" 
                    class="white--text" 
                    top outlined dense
                    type="error" text>
                    {{ error }}
                    <v-btn color="white" flat text  @click="alert_error = false"> Close</v-btn>
                </v-snackbar>
           </v-flex>
            <v-flex xs12>
                <div>
                    <v-layout row wrap fill-height class="pa-2 header">
                        <v-flex xs12 sm3 md2>
                            <div class="title text-color">Vendors</div>
                        </v-flex>
                        <v-flex xs12 sm9 md10 class="filter_form pl-3">
                            <v-form @submit.prevent="validateBeforeSubmit('filterList')" data-vv-scope="filterList" id="filterList" ref="form">
                                <v-layout row wrap>
                                    <v-flex xs6 sm12 md4>
                                        <v-text-field name="Name" label="Search By Name" id="name" regular single-line v-model="filters.name"></v-text-field>
                                    </v-flex>
                                    <!-- <v-flex xs6 sm12 md2>
                                        <v-menu v-model="from_menu" :close-on-content-click="false" transition="scale-transition" :nudge-right="40" offset-y max-width="290px" min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field label="From Date" readonly v-on="on" regular single-line name="From date" v-model="filters.from_date" :error-messages="errors.collect('filterList.From Date')"></v-text-field>
                                            </template>
                                            <v-date-picker v-if="from_menu" v-model="filters.from_date" @input="from_menu = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs6 sm4 md2>
                                        <v-menu v-model="to_menu" :close-on-content-click="false" transition="scale-transition" :nudge-right="40" offset-y max-width="290px" min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field label="To Date" readonly v-on="on" regular single-line name="to date" v-model="filters.till_date" :error-messages="errors.collect('filterList.Till Date')"></v-text-field>
                                            </template>
                                            <v-date-picker v-if="to_menu" :min="this.filters.from_date" v-model="filters.till_date" @input="to_menu = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex> -->
                                    <v-flex xs6 sm12 md8 class='buttoncenter pl-5'>
                                        <v-btn small color="primary" type="submit">Apply</v-btn>
                                        <v-btn small color="primary" class="btn_reset ml-1" @click="resetFilter">Reset</v-btn>
                                        <v-btn small color="primary" class="float_right ml-1" to="/addVendor">Create Vendor</v-btn>
                                        <v-btn small color="primary" class="float_right" @click="upload_vendor_dialog_box=true">Upload Vendors</v-btn>
                                    </v-flex>
                                    <!-- <v-flex xs6 sm5 md5 class='buttoncenter pl-5'>
                                        <v-btn small color="primary" class="float_right" @click="upload_office_dialog_box=true">Uplode Office</v-btn>
                                    </v-flex> -->
                                </v-layout>
                            </v-form>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex sm12 md12>
                            <v-data-table 
                            :headers="headers" 
                            :items="vendors"
                            item-key="id" 
                            class="elevation-1" 
                            :loading="is_loading" 
                            :options.sync="options" 
                            :server-items-length="total_items" 
                            :footer-props="{'items-per-page-options': [15,20,40,80]}" 
                            :items-per-page="15">
                                <template v-slot:body="{ items }" v-if="!is_loading && total_items!='0'">
                                    <tbody>
                                        <tr v-for="item in items" :key="item.id">
                                            <td>
                                                <router-link :to="{ name:'showVendorDetails',params: { id:item.id } }">{{ item.name |capitalize}}</router-link>
                                            </td>

                                            <td v-if="item.mobile">{{ item.mobile }}</td><td v-else> - </td>
                                            <td v-if="item.email">{{ item.email }}</td>
                                            <td v-else> - </td>
                                            <td v-if="item.created_at">{{ formatDate(item.created_at) }}</td><td v-else> - </td>
                                        </tr>
                                    </tbody>
                                </template>  <template v-slot:loading> Loading... Please wait </template>
                        <template v-slot:no-results> No data available </template>
                            </v-data-table>
                        </v-flex>

                    </v-layout>
                </div>

            </v-flex>
        </v-layout>

    <!-- Upload Vendor model -->
    <v-dialog v-model="upload_vendor_dialog_box" scrollable :overlay="false" max-width="600px" min-height="800px" transition="dialog-transition">
        <v-card class="pa-4">
            <v-form>
                  <v-card-title>
                    <p class="text-color pb-0">Upload file</p>
                </v-card-title>
                <v-card-text>
                    <v-file-input
                            v-model="files"
                            label="File input"
                            placeholder="Select your files"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                            :show-size="1000"
                        ></v-file-input>
                </v-card-text>
                <v-card-text>
                    <a v-bind:href="`${publicPath}/files/Vendor_Sample_Template.xlsx`" download><u><b>Download Sample File</b></u></a>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="uploadfile">Upload</v-btn>
                    <v-btn color="black" text small @click="upload_vendor_dialog_box=false">Cancel</v-btn>
                </v-card-actions>      
            </v-form>
        </v-card>
    </v-dialog>
    </v-container>
</div>
</template>

<script>
export default {
    watch: {
        options: {
            handler() {
                this.getList();
            }
        }
    },
    methods: {
        getList: function () {
            this.is_loading = true;
            this.options.filters = Object.assign({}, this.filters);
            axios.get(`${process.env.VUE_APP_API_URL}/api/vendors`, {
                params: this.options
            }).then((response) => {

                if (response.data.status == 1) {
                    this.vendors = response.data.vendors_list.data;
                    this.total_items = response.data.vendors_list.total;
                    this.is_loading = false;
                }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {
                    this.is_loading = false;
                }
            });

        },
        validateBeforeSubmit: function (scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this[scope]();
                }
            });
        },
        filterList() {
            let filter_values = Object.values(this.filters);
            if (filter_values.join('').length > 0) {
                this.$router.replace({
                    name: "vendors",
                    query: {
                        filters: true,
                        name: this.filters.name,
                        from_date: this.filters.from_date,
                        till_date: this.filters.till_date,

                    }
                });
                this.displayFilterChips(this.filters);
                this.is_filtered = true;
            } else {
                this.$router.replace({
                    name: "vendors"
                });
            }
            this.getList();
            this.filter_dialog_box = false;
        },
        clearFilter: function (filter, key) {
            this.filter_chips[key] = this.filters[key] = '';
            this.filterList();
        },
        resetFilter() {
            this.resetFiltersParameters();
            this.$router.replace({
                name: 'vendors',
                query: {}
            });
            this.getList();
            this.resetFiltersParameters();
            this.is_filtered = false;
            this.filter_dialog_box = false;
        },
        resetFiltersParameters: function () {
            for (var key in this.filters) {
                this.filters[key] = '';
                this.filter_chips[key] = '';
            }
        },
        applyFiltersOnLoad: function () {
            this.filters.name = this.$route.query.name;
            this.filters.from_date = this.$route.query.from_date;
            this.filters.till_date = this.$route.query.till_date;
            this.displayFilterChips(this.filters);
        },
        displayFilterChips: function (filters) {
            if (this.$route.query.filters) {
                this.filter_chips.name = filters.name;
                this.filter_chips.from_date = filters.from_date;
                this.filter_chips.till_date = filters.till_date;
                this.is_filtered = true;
            }
        },
       
        uploadfile: function () {
            let formData = new FormData();
            formData.append('file', this.files);
            axios.post(`${process.env.VUE_APP_API_URL}/api/vendors/uploadvendors`,
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then((response) => {
                    this.upload_vendor_dialog_box = false;
                    if (response.data.status == 1) {
                        // this.$router.push({ name: 'offices', });
                    this.loading = false;
                    this.alert=true;
                    this.message = response.data.message;
                    }
                    if (response.data.status == 0) {
                        this.alert_error=true;
                        this.error = response.data.message
                    }
                })
                .catch(function () {

                });

        },

        applycolumnfilter: function () {
            if (this.role == 'Super Admin') {
                this.headers = [{
                        text: 'Name',
                        value: 'name',
                        sortable: false,
                    },
                    {
                        text: 'Mobile',
                        value: 'mobile',
                        sortable: false,
                    },
                    {
                        text: 'Email',
                        value: 'email',
                        sortable: false,
                    },
                    {
                        text: 'Created On',
                        value: 'created_at',
                        sortable: false,
                    },

                ];
            }
            if (this.role == 'Society Admin') {
                this.headers = [{
                        text: 'Name',
                        value: 'visitor_id',
                        sortable: false,
                    },
                    {
                        text: 'Mobile',
                        value: 'mobile',
                        sortable: false,
                    },
                    {
                        text: 'Email',
                        value: 'email',
                        sortable: false,
                    },
                    {
                        text: 'Created On',
                        value: 'created_at',
                        sortable: false,
                    },

                ];
            }
        }
    },
    data() {
        return {
            options: {},
            role: '',
            total_items: 0,
            headers: [],
            vendors: [],

            filters: {
                name: '',
                from_date: '',
                till_date: '',
            },
            filter_chips: {
                name: '',
                from_date: '',
                till_date: '',
            },

            from_date_menu: false,
            to_date_menu: false,
            from_menu: false,
            to_menu: false,
            files:null,
            is_loading: false,
            is_filtered: false,
            default_visitor_image: "/visits_images/index.png",
            upload_vendor_dialog_box:false,
            error:'',
            message:'',
            alert: false,
            alert_error:false,
            publicPath: process.env.VUE_APP_URL,
        }
    },
    mounted() {
        this.role = localStorage.getItem('visitor_management_role');
        this.applycolumnfilter();
        this.applyFiltersOnLoad();
    },
};
</script>
